import Swiper from 'swiper';
import 'swiper/css';

export const coursesSwiper = ()=> {
    new Swiper('.courses-swiper', {
        slidesPerView: 1.2,
        spaceBetween: 20,

        breakpoints: {
            600: {
                slidesPerView:1.5,
            },
            768: {
                slidesPerView:2,
            },
            1024: {
                slidesPerView:3,
            },
            1280: {
                slidesPerView:4,
            }
        }
    });
}
